import { Type } from '@angular/core';
import { IAdminModalData } from './models/admin-modal';

export class AdminModalItem {
	constructor(public component: Type<any>, public data: IAdminModalData<{}>) {
	}
}
